import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch } from '@/store/hooks'
import { useGoToLessonSettings } from './useLessonLastBlock'
import {
  selectBlock,
  selectLesson,
  setContentLang,
  type ContentLang,
} from '@/features/editor/editorSlice'

const positiveId = (raw: string | null): number | null => {
  const n = Number(raw)
  return raw !== null && Number.isInteger(n) && n > 0 ? n : null
}

const contentLangOf = (raw: string | null): ContentLang | null =>
  raw === 'ru' || raw === 'en' ? raw : null

/**
 * «Перейти» у нарушения со страницы настроек приходит в редактор `?lesson=&block=`
 * (`CourseSettingsPage`). Разбор разовый: параметры снимаются с `replace`, иначе
 * обновление страницы снова прыгало бы к нарушению, а «Назад» вёл бы на него же.
 */
export const useViolationJumpParams = () => {
  const dispatch = useAppDispatch()
  const goToLessonSettings = useGoToLessonSettings()
  const [searchParams, setSearchParams] = useSearchParams()
  useEffect(() => {
    if (!searchParams.has('lesson') && !searchParams.has('block')) return
    const lessonId = positiveId(searchParams.get('lesson'))
    if (lessonId !== null) {
      // Пропуск на другом языке: на языке правки его не было бы видно.
      const lang = contentLangOf(searchParams.get('lang'))
      if (lang !== null) dispatch(setContentLang(lang))
      // selectLesson гасит выбранный блок — блок выбираем ПОСЛЕ него.
      const blockId = positiveId(searchParams.get('block'))
      if (blockId === null) {
        goToLessonSettings(lessonId)
      } else {
        dispatch(selectLesson(lessonId))
        dispatch(selectBlock(blockId))
      }
    }
    setSearchParams({}, { replace: true })
  }, [searchParams, setSearchParams, dispatch, goToLessonSettings])
}
